
import request from "@/utils/request.js";
export function getDict(dictType){
    return request({
        url:"/system/material/api/dict/data/type/" + dictType,
        method:"GET",
    })
}